import { Grid } from '@material-ui/core';
import axios from 'axios';
import cloneDeep from 'clone-deep';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import {
    generateConstructFromFilterColumns,
} from '../../../components/GenericFilterComponent/GenericFilterComponentUtil';
import GenericFilterWithSearch from '../../../components/GenericFilterComponent/GenericFilterWithSearch';
import IframeDialogComponentV2 from '../../../components/IframeDialogComponentV2/IframeDialogComponentV2';
import MaterialTable from '../../../components/MaterialTableV2/MaterialTable';
import {
    getJsonPath,
    getSeekParamsAndDirection,
    getStartAndEndDateFromOrderTypeDateFilter,
} from '../../../constants/CommonUtil';
import { iframeUrlMap, PAGE, SIZE } from '../../../constants/constants';
import { getStringFromObject } from '../../../constants/lodashUtils';
import { isObjectValidAndNotEmpty } from '../../../constants/nullCheckUtils';
import {
    fetchDeliveryNotes,
} from '../../../redux/modules/corporateSalesDeliveryNotes/corporateSalesDeliveryNotes-actions';
import { errorMessage } from '../../../redux/modules/message/message-actions';
import { displayWarning } from '../../../redux/modules/warningDialog/warningDialog-actions';
import { COMBINEMODE, getCombined } from '../../../sagas/util';
import {
    CORPORATE_SALES_DELIVERY_NOTES_FILTER_SCHEMA,
    createSearchConstructForDeliveryNotes,
} from '../CorporateSalesDeliveryNotes/CorporateSalesDeliveryNotesContainerUtil';

class CorporateSalesRefundsContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            totalElements: 0,
            schema: {},
            openIframeDialog: false,
            iframeProps: {},
        };
    }

    componentDidMount() {
        const { filterValues, size } = this.props;
        this.fetchSchema();
        this.fetchRefunds(0, size, filterValues);
    }

    fetchSchema = async () => {
        const { dispatch } = this.props;
        try {
            const schemaResp = await axios.get(getJsonPath('/CorporateSales/CorporateSalesDeliveryNote.json'));
            this.setState({ schema: schemaResp.data });
        } catch (error) {
            dispatch(errorMessage(`There has been a problem with your fetch operation:${error.message}`));
        }
    };

    fetchRefunds = async ({ page: newPage_, size: newSize_, filters: newFilters_ }) => {
        const {
            dispatch,
            forwardSeekMap,
            backwardSeekMap,
            filterValues,
            page,
            size,
        } = this.props;
        const newPage = newPage_ || newPage_ === 0 ? newPage_ : page;
        const newSize = newSize_ || newSize_ === 0 ? newSize_ : size;
        const newFilters = newFilters_ || filterValues;
        const {
            seekParams,
            seekDirection,
        } = getSeekParamsAndDirection(newPage, page, forwardSeekMap, backwardSeekMap);
        const dateAndTextSearch = createSearchConstructForDeliveryNotes(
            { ...newFilters },
            true,
        );

        let searchConstruct = generateConstructFromFilterColumns(
            CORPORATE_SALES_DELIVERY_NOTES_FILTER_SCHEMA(true), newFilters,
        );
        if (isObjectValidAndNotEmpty(dateAndTextSearch)) {
            searchConstruct = getCombined(searchConstruct, COMBINEMODE.AND, dateAndTextSearch);
        }
        dispatch(fetchDeliveryNotes(newPage, newSize, searchConstruct, seekParams, seekDirection, newFilters, true));
    };

    handlePageChange = (page, size) => {
        this.fetchRefunds({ page, size });
    };

    handleRowClick = (_e, _index, _uniqueKey, rowValue) => {
        const { uuid, shippingType } = rowValue;
        const { iframeFormsBase } = this.props;
        if (shippingType === 'corporate_in') {
            this.setState({
                openIframeDialog: true,
                iframeProps: {
                    header: 'Corporate Sales - Refunds',
                    iframeUrl: `${iframeFormsBase}${iframeUrlMap.STOCK_PICKING}?stockOperation=CORPORATE_IN&stockPickingUuid=${uuid}`,
                },
            });
        } else if (shippingType === 'inter_branch_in') {
            this.setState({
                openIframeDialog: true,
                iframeProps: {
                    header: 'Inter Branch Refund',
                    iframeUrl: `${iframeFormsBase}${iframeUrlMap.STOCK_PICKING}?stockOperation=INTER_BRANCH_IN&stockPickingUuid=${uuid}`,
                },
            });
        } else if (shippingType === 'external_transfer_in') {
            this.setState({
                openIframeDialog: true,
                iframeProps: {
                    header: 'External Transfer Refund',
                    iframeUrl: `${iframeFormsBase}${iframeUrlMap.STOCK_PICKING}?stockOperation=EXTERNAL_TRANSFER_IN&stockPickingUuid=${uuid}`,
                },
            });
        }
    };

    handleCloseIframeDialog = () => {
        this.props.dispatch(
            displayWarning(
                'Any unsaved changes will be lost, are you sure want to continue ?',
                () => {
                    this.setState({ openIframeDialog: false, iframeProps: {} });
                    this.fetchRefunds({});
                },
            ),
        );
    };

    handleApplyFilter = (filters) => {
        const {
            size,
        } = this.props;
        let appliedFilters = {};
        if (isObjectValidAndNotEmpty(filters.datePeriod)) {
            appliedFilters = cloneDeep(filters);
        } else {
            appliedFilters = {
                ...filters,
                datePeriod: {
                    period: 'Past 7 Days',
                    startDate: getStartAndEndDateFromOrderTypeDateFilter('Past 7 Days').startDate,
                    endDate: getStartAndEndDateFromOrderTypeDateFilter('Past 7 Days').endDate,
                },
                searchText: '',
            };
        }
        this.fetchRefunds({ page: 0, size, filters: appliedFilters });
    };

    render() {
        const {
            totalElements,
            schema,
            iframeProps,
            openIframeDialog,
        } = this.state;
        const {
            deliveryNotesList,
            page,
            size,
            first,
            last,
            filterValues,
        } = this.props;

        return (
            <React.Fragment>

                <Grid container spacing={8}>
                    <Grid item container sm={12} justify="space-between">
                        <Grid item lg={8} md={4} sm={8}>
                            <GenericFilterWithSearch
                                filterSchema={CORPORATE_SALES_DELIVERY_NOTES_FILTER_SCHEMA(true)}
                                filterValues={filterValues}
                                saveFilter={this.handleApplyFilter}
                                placeholder="Search with number"
                            />
                        </Grid>
                    </Grid>
                    {
                        isObjectValidAndNotEmpty(schema) && (
                            <Grid item sm={12}>
                                <MaterialTable
                                    schema={schema}
                                    page={page}
                                    size={size}
                                    data={deliveryNotesList}
                                    onRowClick={this.handleRowClick}
                                    onPageChange={this.handlePageChange}
                                    totalElements={totalElements}
                                    first={first}
                                    last={last}
                                    seekablePagination
                                />
                            </Grid>
                        )
                    }
                </Grid>
                {
                    openIframeDialog && isObjectValidAndNotEmpty(iframeProps) && (
                        <IframeDialogComponentV2
                            {...iframeProps}
                            open
                            fullScreen
                            handleClose={() => this.handleCloseIframeDialog()}
                        />
                    )
                }
            </React.Fragment>
        );
    }
}

CorporateSalesRefundsContainer.propTypes = {
    iframeFormsBase: PropTypes.string.isRequired,
    dispatch: PropTypes.func,
    forwardSeekMap: PropTypes.object,
    backwardSeekMap: PropTypes.object,
    filterValues: PropTypes.object,
    page: PropTypes.number,
    size: PropTypes.number,
    deliveryNotesList: PropTypes.array,
    first: PropTypes.bool,
    last: PropTypes.bool,
};

CorporateSalesRefundsContainer.defaultProps = {
    dispatch: () => {},
    forwardSeekMap: null,
    backwardSeekMap: null,
    first: false,
    last: false,
    page: PAGE,
    size: SIZE,
    deliveryNotesList: [],
    filterValues: {
        datePeriod: {
            period: 'Past 7 Days',
            startDate: getStartAndEndDateFromOrderTypeDateFilter('Past 7 Days').startDate,
            endDate: getStartAndEndDateFromOrderTypeDateFilter('Past 7 Days').endDate,
        },
    },
};

const mapStateToProps = state => ({
    iframeFormsBase: getStringFromObject('appConfiguration.iframeFormsBase', state) || '',
    forwardSeekMap: state.corporateSalesRefund.forwardSeekMap,
    backwardSeekMap: state.corporateSalesRefund.backwardSeekMap,
    deliveryNotesList: state.corporateSalesRefund.list,
    filterValues: state.corporateSalesRefund.filterValues,
    page: state.corporateSalesRefund.page,
    size: state.corporateSalesRefund.size,
    first: state.corporateSalesRefund.first,
    last: state.corporateSalesRefund.last,
});

export default connect(mapStateToProps)(CorporateSalesRefundsContainer);
